import {Component, inject, input} from "@angular/core";
import {ReplicationStateSession, ReplicationStateType, SimStatusPalette} from "@models";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {DatePipe} from "@angular/common";
import {Translations} from "../../../../../sim.translations.barrel";

@Component({
	selector: "sim-session-replication-state-tag",
	imports: [MatIcon, TranslateModule, DatePipe],
	templateUrl: "./session-replication-state-tag.component.html",
	styleUrl: "./session-replication-state-tag.component.scss",
})
export class SessionReplicationStateTagComponent {
	protected readonly T = Translations;
	protected readonly SimStatusPalette = SimStatusPalette;
	protected readonly ReplicationStateType = ReplicationStateType;

	public readonly sessionReplicationState = input<ReplicationStateSession | null>(null);
	public readonly sessionReplicationStateError = input<string | null>(null);

	public readonly translate = inject(TranslateService);
}
